import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Calculator, Calendar } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 bg-white animate-on-scroll opacity-0">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
          Ready to Get Your Twin Cities Detail?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          Contact us today for a free quote or book your detailing appointment online
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-6">
          <Button
            size="lg"
            className="bg-primary hover:bg-primary/90 text-white px-8 py-6 text-lg hover:scale-105 transition-transform"
            asChild
          >
            <Link to="/quote" className="flex items-center gap-2">
              <Calculator className="h-5 w-5" />
              Get Free Quote
            </Link>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-primary text-primary hover:bg-primary hover:text-white px-8 py-6 text-lg hover:scale-105 transition-transform"
            asChild
          >
            <Link to="/booking" className="flex items-center gap-2">
              <Calendar className="h-5 w-5" />
              Book Now
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
